var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeacher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5697 19.26V26.655C27.5697 28.56 26.0847 30.6 24.2997 31.2L19.5147 32.79C18.6747 33.075 17.3097 33.075 16.4847 32.79L11.6997 31.2C9.89969 30.6 8.42969 28.56 8.42969 26.655L8.44469 19.26L15.0747 23.58C16.6947 24.645 19.3647 24.645 20.9847 23.58L27.5697 19.26Z",
    fill: "#5A5AF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9703 9.69003L20.9853 3.79503C19.3653 2.73003 16.6953 2.73003 15.0753 3.79503L6.04527 9.69003C3.15027 11.565 3.15027 15.81 6.04527 17.7L8.44527 19.26L15.0753 23.58C16.6953 24.645 19.3653 24.645 20.9853 23.58L27.5703 19.26L29.6253 17.91V22.5C29.6253 23.115 30.1353 23.625 30.7503 23.625C31.3653 23.625 31.8753 23.115 31.8753 22.5V15.12C32.4753 13.185 31.8603 10.935 29.9703 9.69003Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/teacher.da65095d56e160fb7e8069c4e0368bf4.svg";
export { ForwardRef as ReactComponent };